import { ChangeDetectorRef, Component } from '@angular/core';
import { AuthService } from '@services/auth/auth.service';
import { IsAdminService } from '@services/is-admin/is-admin.service';
import { UiService } from '@services/ui/ui.service';
import { SubscriptionBaseComponent } from './shared/subscription-base/subscription-base';
import { MediaMatcher } from '@angular/cdk/layout';
import { MatSidenav } from '@angular/material/sidenav';
import { environment } from '@environments/environment';
import { AppConfigService } from '@services/app-config/app-config.service';
import { NotificationService } from '@services/notifications/notification.service';
import { NavigationStart, Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent extends SubscriptionBaseComponent {
  title = 'smart-parking';
  public snapshotImageName: string = "sample_snapshot";
  public snapshotImageType: string = "JPG";

  isAuth: boolean;
  isMaintenance: boolean;
  isError: boolean;
  isRouteLoading: boolean;
  isTranslationLoading: boolean;
  isStandAlone: boolean;

  navMode = 'side';
  mobileQuery: MediaQueryList;

  private mobileQueryListener: () => void;

  constructor(
    private configSrv: AppConfigService,
    private uiSrv: UiService,
    private authSrv: AuthService,
    private changeDetectorRef: ChangeDetectorRef,
    private media: MediaMatcher,
    private notificationsSrv: NotificationService,
    private isAdminService: IsAdminService,
    private router: Router
  ) {
    super();
    this.mobileQuery = media.matchMedia('(max-width: 999px)');
    this.mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this.mobileQueryListener);
    this.isMaintenance = configSrv.isMaintenance;

  }

  ngOnInit(): void {

    this.isAdminService.ifIsAdmin(this.authSrv.getDecodedToken()?.role);
    this.isAuth = this.authSrv.isAuth();
    this.initSubscriptions();
    this.initNotifications();

  }



  toggleSidenav(sidenav: MatSidenav, isToggle?: boolean): void {
    if (isToggle) {
      sidenav.toggle();
    } else if (this.mobileQuery.matches) {
      sidenav.close();
    }
  }

  private initNotifications(): void {

    if (this.isAuth) {
      this.notificationsSrv.init();
    }
  }




  private initSubscriptions(): void {
    this.subscription.add(
      this.uiSrv.routeLoadingStateChanged
        .subscribe(loadingState => {
          this.isRouteLoading = loadingState;
        })
    );

    this.subscription.add(
      this.uiSrv.translationLoadingStateChanged
        .subscribe(loadingState => {
          this.isTranslationLoading = loadingState;
        })
    );

    this.subscription.add(
      this.authSrv.authChanged
        .subscribe(authStatus => {
          if (this.isAuth !== authStatus) {
            this.isAuth = authStatus;
            this.initNotifications();

          }
        })
    );

    this.subscription.add(
      this.router.events.subscribe((event: any) => {
        if (event instanceof NavigationStart) {
          this.isStandAlone = event.url.includes('/Wiki');
        }
      })
    );
  }
}
